import React from 'react';
import Video from './video';

interface DynamicContentProps {
    content: any[];
}

const DynamicContent: React.FC<DynamicContentProps> = ({ content }) => {
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';
    return (
        <>
            {content && Array.isArray(content) && content.map((item: any, index: number) => {
                // console.log("Dynamic Content-1", item);
                if (item.__component === "components.editor") {
                    return <section className="gradientCard container" key={index}>
                        <div className="gradientCard-content">
                            <div className="pattern"></div>
                            <div className="content">
                                <div className='lists'><div dangerouslySetInnerHTML={{ __html: item.Table_list }} />
                                </div>
                            </div>
                        </div>
                    </section>
                } else if (item.__component === "components.video") {
                    return <Video key={index} videoData={item.Video} />;
                } else if (item.__component === "page-template.grid-2-editor-media") {
                    return <section className='growth-info container' key={index}>
                        <h2>{item.Header}</h2>
                        <div className='content'>
                            {item.EditorMedia.map((editorItem: any, editorIndex: number) => (
                                <div className='item' key={editorIndex}>
                                    <div className='desc' dangerouslySetInnerHTML={{ __html: editorItem.Description }}></div>
                                    <div className='grap'>
                                        <img src={`${locateSrc}${editorItem.Graphic.url}`} alt={item.Header} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>;
                } else if (item.__component === "page-template.tpl-agentic-ai") {
                    return <section className='education-card container' key={index}>
                        <h2>{item.Header}</h2>
                        <div className='item-container'>
                            {item.Cards.map((editorItem: any, editorIndex: number) => (
                                <div className='item' key={editorIndex}>
                                    <div className='icon'><img src={`${locateSrc}${editorItem.Icon.url}`} alt={editorItem.Percentage} /></div>
                                    <div className='content'>
                                        <div className='desc' dangerouslySetInnerHTML={{ __html: editorItem.Description }}></div>
                                        <h3>{editorItem.Title}</h3>
                                        <div className='percentage'>{editorItem.Percentage}</div>
                                        <div className='remark'>{editorItem.Remark}</div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </section>
                } else if (item.__component === "page-template.tpl-productivity") {
                    console.log("Dynamic Content-Productivity", item);
                    return <section className="agentic">
                         <div className="container">
                        <div className="contentA">
                            <h2>{item.Header}</h2>
                            <div className="details">
                                 <div className='dec' dangerouslySetInnerHTML={{ __html: item.Description }}></div>
                                <div className='graph'><img src={`${locateSrc}${item.Graphic.url}`} alt="Productivity of Agentic AI" /></div>
                            </div>
                            <div className='note'>{item.Remark}</div>
                        </div>
                        <div className="contentB">
                            {item.Card.map((editorItem: any, editorIndex: number) => (
                                <div className='item' key={editorIndex}>
                                <div className='pancentage'>
                                    <div className='value'>{editorItem.title}</div>
                                    <div className='icon'><img src={`${locateSrc}${editorItem.icon.url}`} alt={editorItem.title} /></div>
                                </div>
                                <div className='desc'>{editorItem.Content}</div>
                            </div>
                            ))}
                           
                        </div>
                        <div className='remark'>{item.Remark2}</div>
                    </div>
                    </section>
                }
                return null;
            })}
        </>
    );
};

export default DynamicContent;